import reducer from "./reducer";
export { default as SystemAndUserTablesDefinition } from "./components/index";
export { default as systemAndUserTablesDefinitionReducerName } from "./constants";
export default reducer;
